import React from 'react';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import SubmitButton from '../SubmitButton';

type Props = {
  handler: () => void;
  text: React.ReactNode;
};

const FacebookLoginButton = ({ text, handler }: Props) => {
  const variantButton = text === StringConstantsMixin.strings.FACEBOOK.FACEBOOK_SETTINGS ? 'facebookSettings' : 'facebookLogin';

  return <SubmitButton text={text} handler={handler} variant={variantButton} dataTestId="facebookLoginButton" />;
};

export default FacebookLoginButton;
